import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=610c866c&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610c866c')) {
      api.createRecord('610c866c', component.options)
    } else {
      api.reload('610c866c', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=610c866c&", function () {
      api.rerender('610c866c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2po2wJ9001te8/JS/priceformat.vue"
export default component.exports